/**
 * The origin every absolute URL the site emits is built from.
 *
 * This existed three times independently before DMX-047: structured-data-utils.ts,
 * generate-sitemap.ts and scripts/generate-sitemap.js each declared the same constant with
 * the same fallback, while SEO.tsx and prerender.js hardcoded the production host outright.
 * The hardcodes are why the dev environment could not be used to check anything a crawler
 * reads: demirix.dev served og:image and canonical pointing at demirix.com, so a link
 * preview of a dev URL fetched a production asset that did not exist yet.
 *
 * Set VITE_SITE_URL per environment. The fallback is the production origin, so a build with
 * no variable set produces exactly the output it always did.
 *
 * scripts/ cannot import this, because those run in plain Node where import.meta.env does
 * not exist. They read process.env.VITE_SITE_URL with the same fallback instead.
 */
export const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://demirix.com'

/**
 * Every preview image this site emits is 1200 by 630.
 *
 * Declared once here because SEO.tsx publishes it to consumers as og:image:width and
 * og:image:height, and src/test/lib/og-image.test.ts fails if any referenced image is a
 * different size. A declared size that does not match the file is worse than none, since
 * the consumer reserves the wrong box and then paints into it.
 */
export const OG_IMAGE_SIZE = { width: 1200, height: 630 } as const
